import { ref } from 'vue'

const PARAM = 'voyada'
export const STORAGE_KEY = 'ttg_voyada_enabled'

export function resolveVoyadaFlag(search: string): boolean {
  localStorage.removeItem(STORAGE_KEY)
  const params = new URLSearchParams(search)
  if (params.has(PARAM)) {
    return params.get(PARAM) !== '0'
  }
  return true
}

const _enabled = resolveVoyadaFlag(window.location.search)

export const voyadaHeroMode = ref<'voyada' | 'classic'>(_enabled ? 'voyada' : 'classic')

export function useVoyadaFlag() {
  return { enabled: ref(_enabled) }
}
